import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type ReliableLocksProps = {
  onConsultationSignupBtnClick: () => void;
};

export const ReliableLocks = ({ onConsultationSignupBtnClick }: ReliableLocksProps) => (
  <>
    <ModalHeader title="Надёжная система замков" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Для основных замков мы&nbsp;предлагаем только высокие классы взломостойкости&nbsp;&mdash;
        от&nbsp;3&nbsp;до&nbsp;4. При&nbsp;необходимости, установим дополнительную защиту в&nbsp;виде ночной
        задвижки.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementName="Надёжная система замков"
        elementText="Оставить заявку"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
